import { Component, OnInit } from '@angular/core';
import { BaseComponent } from "@bt/core/base";
import { NotifierService } from 'angular-notifier';
import { StoredJobService } from "@bt/core/services/storedJob.service";
import { faPlus, faPen, faTimes, faPause, faPlay, faClock } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { showConfirmation } from "@bt/confirmation-modal/confirmation.modal";
import { JobInfo } from "@bt/core";
import { boolToString } from "@bt/core/utils/convert";
import { buildCatchingApiError, buildCatchingHttpError } from "@bt/core/utils/catchingException";
import { IResponse } from "@bt/shared";
import * as moment from "moment";
import { CoinPurchaseInfoService } from "@bt/auto-coin-purchase/services/coinPurchaseInfo.service";
import { CoinPurchaseHistory } from "@bt/auto-coin-purchase/models/CoinPurchaseHistory.model";

@Component({
  selector: 'app-auto-coin-purchase',
  templateUrl: './auto-coin-purchase.component.html',
  styleUrls: ['./auto-coin-purchase.component.scss']
})
export class AutoCoinPurchaseComponent extends BaseComponent implements OnInit {
  private readonly jobGroup = "AutoCoinPurchase";

  private isCaughtApiError: (response: IResponse<any>) => boolean;
  private catchRequestError: (error: { message: string }) => void;

  protected readonly faTimes = faTimes;
  protected readonly faPlus = faPlus;
  protected readonly faPen = faPen;
  protected readonly faPlay = faPlay;
  protected readonly faPause = faPause;
  protected readonly faClock = faClock;

  protected readonly boolToString = boolToString;

  protected storedJobs: JobInfo<string>[] = [];

  // TODO добавить отображение на ui
  protected coinPurchaseHistory: CoinPurchaseHistory[] = [];

  constructor(
    private storedJobService: StoredJobService,
    private coinPurchaseInfoService: CoinPurchaseInfoService,
    private notifierService: NotifierService,
    protected modalService: NgbModal,
  ) {
    super();
    const me = this;

    me.isCaughtApiError = buildCatchingApiError(this.notifierService);
    me.catchRequestError = buildCatchingHttpError(this.notifierService);
  }

  ngOnInit() {
    const me = this;
    // Полсекунды должно быть достаточно, чтобы параметры задачи сохранились после редактирования
    setTimeout(() => me.loadJobs(), 500);
  }

  /**
   * Загружает список процессов, настроенных на покупку монет
   */
  public loadJobs() {
    const me = this;
    me.storedJobService.getAllStoredJobs(me.jobGroup)
      .then(response => {
        if (!me.isCaughtApiError(response)) {
          me.storedJobs = response.data || [];
        }
      })
      .catch(me.catchRequestError);
    me.coinPurchaseInfoService.getCoinPurchaseHistory()
      .then(response => {
        if (!me.isCaughtApiError(response)) {
          me.coinPurchaseHistory = response.data || [];
        }
      })
      .catch(me.catchRequestError);
  }

  /**
   * Формирует объект с параметрами задачи
   * @param index
   * @protected
   */
  protected getJobParameters(index: number) {
    return {
      ...this.storedJobs[index],
    };
  }

  /**
   * Удаляет задачу
   * @param name Название удаляемой задачи
   */
  public deleteJob(name: string) {
    const me = this;
    showConfirmation({
      modalService: me.modalService,
      question: `Удалить задачу '${name}'?`,
      action: (isNeedDelete) => {
        if (!isNeedDelete)
          return;

        me.storedJobService.deleteStoredJob(name, me.jobGroup)
          .then((response) => {
            me.loadJobs();

            if (me.isCaughtApiError(response))
              return;

            if (response.data) {
              me.notifierService.notify("success", `Удалена задача '${name}'`);
            } else {
              me.notifierService.notify("error", `Не удалось удалить задачу '${name}'`);
            }
          })
          .catch(me.catchRequestError);
      }
    });
  }

  /**
   * Ставит задачу на паузу
   * @param name Название задачи, устанавливаемой на паузу
   */
  public pauseJob(name: string) {
    const me = this;
    me.storedJobService.pauseStoredJob(name, me.jobGroup)
      .then((response) => {
        me.loadJobs();

        if (me.isCaughtApiError(response))
          return;

        me.notifierService.notify("success", `Задача '${name}' поставлена на паузу`);
      })
      .catch(me.catchRequestError);
  }

  /**
   * Снимает задачу с паузы
   * @param name Название задачи, снимаемой с паузы
   */
  public resumeJob(name: string) {
    const me = this;
    me.storedJobService.resumeStoredJob(name, me.jobGroup)
      .then((response) => {
        me.loadJobs();

        if (me.isCaughtApiError(response))
          return;

        me.notifierService.notify("success", `Задача '${name}' снята с паузы`);
      })
      .catch(me.catchRequestError);
  }

  /**
   * Форматирует дату в локальном времени в формате 'D.MM.Y HH:mm:ss'
   * @param date Дата в UTC
   * @protected
   */
  protected formatDate(date: Date) {
    return moment(date).local(true).format('DD.MM.Y HH:mm:ss')
  }
}



// WEBPACK FOOTER //
// ./src/app/auto-coin-purchase/auto-coin-purchase.component.ts